import r from "i18n-iso-countries";
import * as s from "i18n-iso-countries/langs/en.json";
const i = (o) => r.langs().includes(o), n = (o) => {
  r.registerLocale(o);
};
n(s);
const c = async (o) => {
  const e = o.toLowerCase();
  try {
    return await import(
      /* @vite-ignore */
      `i18n-iso-countries/langs/${e}.json`
    ).then((a) => a.default);
  } catch (t) {
    console.error(`Failed to load country locale for: ${e}`, t);
  }
}, u = async (o) => {
  const e = await c(o);
  return e && !i(e.locale) && n(e), e;
};
export {
  i as isLocalizedCountriesRegistered,
  c as loadLocalizedCountries,
  n as registerLocalizedCountries,
  u as utilizeLocalizedCountries
};
